import { OnboardingEventId } from '@thoughtspot/onboarding-event-service';
import {
    TourChainActionType,
    TourChainStep,
} from './checklist-tour-steps.util';

export const getTeamOfAgentsTourChain = (
    taskId: string,
    t: (key: string, params?: Record<string, unknown>) => string,
): TourChainStep[] | null => {
    switch (taskId) {
        case OnboardingEventId.TEAM_OF_AGENTS_DISCOVER_SPOTTER:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_conv-assist-send-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.askQuestion.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.askQuestion.content',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-end',
                        },
                    ],
                    doneButtonText: t(
                        'checklistTour.discoverSpotter.askQuestion.buttonText',
                    ),
                    afterAction: {
                        selector: '[data-tour-id="tour_conv-assist-send-btn"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    condition: () =>
                        !document.querySelector(
                            '[data-testid="error-message"]',
                        ),
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_worksheet-action-menu-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.checkData.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.checkData.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-start',
                        },
                        {
                            target: '[data-tour-id="tour_chat-mode-research-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.researchMode.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.researchMode.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-start',
                        },
                        {
                            target:
                                '[data-tour-id="tour_chat-connectors-button"]',
                            title: t(
                                'checklistTour.discoverSpotter.connectApps.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.connectApps.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-end',
                        },
                    ],
                    showProgress: true,
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_checklist-explore-features-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.findYourWay.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.findYourWay.content',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-end',
                        },
                    ],
                    showOnTourClose: true,
                },
            ];
        case OnboardingEventId.TEAM_OF_AGENTS_DISCOVER_SPOTTERVIZ:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="spotter-viz-chat-input-tour"]',
                            title: t('spotterViz.tour.startWithFirstPrompt'),
                            content: t(
                                'spotterViz.tour.customDatasetConnected',
                            ),
                            disableBeacon: true,
                            placement: 'left',
                        },
                    ],
                    doneButtonText: t('spotterViz.tour.buildThisDashboard'),
                    afterAction: {
                        selector:
                            '[data-tour-id="spotter-viz-chat-input-send-button-tour"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    condition: () =>
                        !document.querySelector(
                            '[data-testid="error-message"]',
                        ),
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="spotter-viz-chat-input-tour"]',
                            title: t(
                                'sparkflow.customize_dashboard.step2.title',
                            ),
                            content: t(
                                'spotterViz.tour.customizeDashboardDescription',
                            ),
                            disableBeacon: true,
                            placement: 'left',
                        },
                        {
                            target:
                                '[data-tour-id="liveboard-styling-edit-header-save-button-tour"]',
                            title: t('spotterViz.tour.saveYourDashboard'),
                            content: t(
                                'spotterViz.tour.saveDashboardDescription',
                            ),
                            disableBeacon: true,
                            placement: 'left',
                        },
                    ],
                    showProgress: true,
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_checklist-explore-features-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.findYourWay.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.findYourWay.content',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-end',
                        },
                    ],
                    showOnTourClose: true,
                },
            ];

        case OnboardingEventId.TEAM_OF_AGENTS_DISCOVER_SPOTTERCODE:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_go_to_playground_button"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.embedWithAgent.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.embedWithAgent.content',
                            ),
                            disableBeacon: true,
                            placement: 'right',
                        },
                    ],
                    dismissOnAfterClick: true,
                    afterAction: {
                        selector:
                            '[data-tour-id="tour_go_to_playground_button"]',
                        type: TourChainActionType.CLICK,
                    },
                    doneButtonText: t(
                        'checklistTour.discoverSpotterCode.embedWithAgent.buttonText',
                    ),
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_embed-dev-portal-chat-input-wrapper"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.stepOne.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.stepOne.content',
                            ),
                            disableBeacon: true,
                            placement: 'left',
                        },
                    ],
                    doneButtonText: t(
                        'checklistTour.discoverSpotterCode.stepOne.buttonText',
                    ),
                    afterAction: {
                        selector:
                            '[data-tour-id="tour_embed-dev-portal-send-message-button"]',
                        type: TourChainActionType.CLICK,
                    },
                },
                {
                    steps: [
                        {
                            target: '[data-tour-id="tour_embed-code-editor"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.stepTwo.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.stepTwo.content',
                            ),
                            disableBeacon: true,
                            placement: 'top',
                        },
                        {
                            target:
                                '[data-tour-id="tour_embed-dev-portal-run-button"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.stepThree.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.stepThree.content',
                            ),
                            disableBeacon: true,
                            placement: 'bottom',
                        },
                    ],
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_checklist-explore-features-btn"]',
                            title: t(
                                'checklistTour.discoverSpotterCode.stepLast.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotterCode.stepLast.content',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-end',
                        },
                    ],
                    showOnTourClose: true,
                },
            ];

        default:
            return null;
    }
};
